import React, { FC }   from 'react';
import {
  Formik,
  Form,
  Field,
  FormikProps,
}                      from 'formik';
import * as Yup        from 'yup';
import styled          from 'styled-components';
import {
  TextInput,
  Button,
}                      from '@components/index';
import { ICarFaxUser } from '@typings/accountManagement';
import { Grid }        from '@material-ui/core';

const CarFaxTitle = styled.p`
  font-weight : 500;
  padding     : 20px 5px;
`;

const StyledField = styled(Field)`&& {
  margin: 0;
}`;

const initialValues: ICarFaxUser = {
  userName: '',
};

const validationSchema: Yup.Schema<ICarFaxUser> = Yup.object().shape({
  userName: Yup.string().required().max(55),
});

interface IProps {
  isAuthorized          : boolean;
  authorizeToCarFax     : (payload: ICarFaxUser) => Promise<void>;
  unauthorizeFromCarFax : () => Promise<void>;
  isLoading             : boolean;
}

export const CarFaxBlock: FC<IProps> = ({
  isAuthorized,
  authorizeToCarFax,
  unauthorizeFromCarFax,
  isLoading,
}) => (
  <>
    <CarFaxTitle>CARFAX Authorization</CarFaxTitle>

    {!isAuthorized ? (
      <Formik
        initialValues    = {initialValues}
        onSubmit         = {authorizeToCarFax}
        validationSchema = {validationSchema}
      >
        {({ isValid }: FormikProps<ICarFaxUser>) => (
          <Form>
            <Grid
              spacing    = {2}
              alignItems = "center"
              container
            >
              <Grid item xs={12} sm={8}>
                <StyledField
                  id          = "userName"
                  name        = "userName"
                  component   = {TextInput}
                  type        = "text"
                  inputProps  = {{ maxLength: 55 }}
                  placeholder = "User Name"
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Button
                  type      = "submit"
                  label     = "Authorize"
                  isLoading = {isLoading}
                  disabled  = {isLoading || !isValid}
                  margin    = "0"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    ) : (
      <Grid item xs={12} sm={4}>
        <Button
          onClick  = {unauthorizeFromCarFax}
          label    = "Unauthorize"
          disabled = {isLoading}
          margin   = "0"
          fullWidth
        />
      </Grid>
    )}
  </>
);
